<template>
  <div class="container">
    <TopHeader title="绑定卡号" returnPath="CardManage"></TopHeader>
    <div class="main-container">
      <div class="main-content">
        <div class="main-title">现卡号</div>
        <div class="main-text">
          <van-field
            placeholder="请输入现卡号"
            input-align="right"
            v-model="form.oldCardSn"
            readonly
          />
        </div>
      </div>
      <CommonBorder></CommonBorder>
      <div class="main-content">
        <div class="main-title">新卡号</div>
        <div class="main-text">
          <van-field
            placeholder="请输入新卡号"
            input-align="right"
            v-model="form.newCardSn"
            maxlength="10"
          />
        </div>
      </div>
      <CommonBorder></CommonBorder>
      <div class="btn-content">
        <van-button size="mini" plain class="btn" @click="handleChange">
          变更
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/topHeader/index.vue';
import CommonBorder from '@/components/commonBorder/index.vue';
import { validCardNumber } from '@/utils/verify';
import { addOrChangeCard } from '@/api/card';
export default {
  components: {
    TopHeader,
    CommonBorder
  },
  data() {
    return {
      form: {}
    };
  },

  created() {
    const { form } = this.$route.query;
    this.form = {
      oldCardSn: JSON.parse(form).cardSn,
      cardId: JSON.parse(form).id
    };
  },

  methods: {
    async handleChange() {
      if (!this.form.oldCardSn) {
        this.$toast('请输入现卡号');
        return;
      }
      if (!this.form.newCardSn) {
        this.$toast('请输入新卡号');
        return;
      }
      if (this.form.oldCardSn === this.form.newCardSn) {
        this.$toast('新卡号不能与现卡号相同');
        return;
      }
      if (
        !validCardNumber(this.form.oldCardSn) ||
        !validCardNumber(this.form.newCardSn)
      ) {
        this.$toast('请输入正确的10位纯数字卡号');
        return;
      }
      const data = {
        newCardSn: this.form.newCardSn,
        oldCardSn: this.form.oldCardSn,
        cardId: this.form.cardId
      };
      const res = await addOrChangeCard(data);
      if (res.code === 0) {
        this.$toast('变更成功');
        this.$router.push({ name: 'CardManage' });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .main-container {
    flex: 1;
    margin-top: 10px;
    .main-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 45px;
      color: #333;
      box-sizing: border-box;
      padding: 0 16px;
      background: #fff;
      .main-title {
        font-size: 16px;
        flex: 1;
      }
      .main-text {
        width: 100px;
        text-align: right;
      }
    }
    .btn-content {
      display: flex;
      justify-content: end;
      flex-direction: row;
      height: 60px;
      box-sizing: border-box;
      padding: 0 16px;
      align-items: center;
      margin-top: 30px;
      .btn {
        width: 100%;
        height: 44px;
        background: #fa5050;
        font-size: 18px;
        color: #fff;
        border-radius: 4px;
        border-color: #fa5050;
      }
    }
  }
}
::v-deep .van-cell {
  height: 40px;
  line-height: 40px;
  padding: 2px;
}
::v-deep .van-toast {
  width: 300px !important;
}
::v-deep .van-toast__text {
  width: 300px !important;
}
</style>
